export default class Config {
  static get domain(): string {
    return process.env.VUE_APP_DOMAIN;
  }

  static get appCode(): string {
    return process.env.VUE_APP_APP_CODE;
  }
  static get client(): string {
    return process.env.VUE_APP_CLIENT;
  }
  static get secret(): string {
    return process.env.VUE_APP_SECRET;
  }

  static get examUrl(): string {
    return process.env.VUE_APP_EXAM_HOST;
  }

  static get baseUrl(): string {
    return process.env.VUE_APP_BASE_URL;
  }

  static get apiUrl(): string {
    return process.env.VUE_APP_API_URL;
  }

  static get apiAppCode(): string {
    return process.env.VUE_APP_API_APP_CODE;
  }

  static get apiAppSecret(): string {
    return process.env.VUE_APP_API_APP_SECRET;
  }

  static get examApiUrl(): string {
    return process.env.VUE_APP_EXAM_API_URL;
  }

  static get aiInterviewUrl(): string {
    return process.env.VUE_APP_AI_INTERVIEW_API_URL;
  }

  static get componentUrl(): string {
    return process.env.VUE_APP_COMPONENT_API_URL;
  }

  static get componentApiAppCode(): string {
    return process.env.VUE_APP_COMPONENT_API_APP_CODE;
  }

  static get componentApiAppSecret(): string {
    return process.env.VUE_APP_COMPONENT_API_APP_SECRET;
  }

  static get loginUrl(): string {
    return process.env.VUE_APP_LOGIN_URL;
  }

  static get accountLoginUrl(): string {
    return process.env.VUE_APP_ACCOUNT_URL;
  }

  static get accountUrl(): string {
    const hostArr = window.location.host.split(".");
    hostArr[0] = "account";
    return window.location.protocol + "//" + hostArr.join(".");
  }

  static get homeUrl(): string {
    return process.env.VUE_APP_HOME_URL;
  }

  static get h5Url(): string {
    return process.env.VUE_APP_h5_URL;
  }

  static get interviewUrl(): string {
    return process.env.VUE_APP_INTERVIEW_URL;
  }
  //富文本上传图片路径
  static get gatewayUrl(): string {
    // const hostArr = window.location.host.split(".");
    // hostArr[0] = "gateway";
    // return window.location.protocol + "//" + hostArr.join(".");
    return process.env.VUE_APP_GATEWAY_URL;
  }

  static get aiInterviewHost(): string {
    return process.env.VUE_APP_AI_INTERVIEW_HOST;
  }

  static get nrHost(): string {
    console.log(process.env);
    return process.env.VUE_APP_NR_HOST;
  }

  static get aiInterviewHomepage(): string {
    return process.env.VUE_APP_AI_INTERVIEW_HOMEPAGE;
  }

  static get homePageHost(): string {
    return process.env.VUE_APP_HOME_PAGE;
  }
}
